import { render } from "./two-factor-authentification.vue?vue&type=template&id=1ba8c09e"
import script from "./two-factor-authentification.vue?vue&type=script&lang=js"
export * from "./two-factor-authentification.vue?vue&type=script&lang=js"

import "./two-factor-authentification.vue?vue&type=style&index=0&id=1ba8c09e&lang=css"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__